

(function($){
    /**
     * ToggleUI component, child of $.OSD
     * initializes instances of ToggleUIButton if elements tagged with the .btn-hide-ui class are found 
     * at the moment the DOM is loaded, these elements must contain the HTML data attributes: data-ui and data-show
     * 
     * data-ui: querySelector of the interface to show or hide
     * data-show: querySelector of the button that will show the ui or the parent element that contains the button as its first child
     */
    $.ToggleUI = function() {
        this._component_name = "toggleui";
        this._toggle_ui_buttons = [];
    };

    $.Component.create($.ToggleUI, {
        _init: function(options) {
            this._options = options || {};
            this._selector = this._options.selector || ".btn-hide-ui";
            ABDOUtil._on_dom_loaded(this._on_dom_content_loaded.bind(this));
        },
        
        _on_dom_content_loaded: function() {
            var toggle_ui_buttons = document.querySelectorAll(this._selector);

            var i, toggle_ui_buttons_n = toggle_ui_buttons.length;
    
            for (i = 0; i < toggle_ui_buttons_n; i++) {
                this._toggle_ui_buttons.push(new $.ToggleUIButton(toggle_ui_buttons[i])); 
            }
            
            this._emit(this._events.ready);
        }
    }, $.OSD);

    $.ToggleUIButton = function(button) {
        // give the ability to pass a string as an id or a querySelector string
        if (typeof(button) === 'string') {
            var element = document.getElementById(button);
            if (element == null) {
                element = document.querySelector(button);
            }
            this._hide_button = element;
        }
        else if (typeof(button) === 'object') {
            this._hide_button = button;
        }

        // allow show_button to be inside a div and separate its parent from the button itself
        this._show_button_ui = document.querySelector(this._hide_button.dataset.show);
        this._show_button = this._show_button_ui;
        if (this._show_button_ui) {
            if (this._show_button_ui.tagName != 'BUTTON') {
                this._show_button = this._show_button_ui.querySelector("button.btn-show-ui");
            }
        }
        this._show_button_ui.style.visibility = 'hidden';

        // UI elements to toggle
        this._ui = document.querySelectorAll(this._hide_button.dataset.ui);
        // console.log(this._hide_button.dataset.ui);

        // if all the objects are set, add the event listener
        if (this._ui && this._show_button && this._show_button_ui) {
            this._hide_button.addEventListener(ABDOUtil.getClickHandler(this._hide_button), this._on_hide_click.bind(this));
            this._show_button.addEventListener(ABDOUtil.getClickHandler(this._show_button), this._on_show_click.bind(this));
        }

    };

    $.ToggleUIButton.prototype = {
        _on_hide_click: function(e) {
            for (var i = 0; i < this._ui.length; i++) {
                var ui = this._ui[i];
                ui.style.transition = 'opacity 0.5s';
                ui.style.visibility = 'hidden';
                ui.style.opacity = 0; 
            }
            
            this._show_button_ui.style.visibility = '';
            this._show_button_ui.style.opacity = 1;
        },

        _on_show_click: function(e) {
            for (var i = 0; i < this._ui.length; i++) {
                var ui = this._ui[i];

                ui.style.visibility = '';
				ui.style.opacity = 1;
            }
            this._show_button_ui.style.transition = 'opacity 0.5s';
            this._show_button_ui.style.visibility = 'hidden';
            this._show_button_ui.style.opacity = 0;
        }
    };


})(ABDOMap);